// Currency utility for Turkish Lira
export const formatCurrency = (amount) => {
  return `₺${Number(amount).toFixed(2)}`;
};

export const CURRENCY_SYMBOL = '₺';
export const CURRENCY_CODE = 'TRY';
